// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { ProductionDeclarationStatementPage } from '@/pages/production-declaration/production-declaration-statement-page';
import { Route as ProductionDeclarationRoute } from './production-declarations.$id';

export const Route = createRoute({
  getParentRoute: () => ProductionDeclarationRoute,
  path: 'statement',
  component: () => <ProductionDeclarationStatementPage />,
  staticData: {
    stepKey: 'statement',
  },
});
